import { makeStyles } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import MapPoint from "./MapPoint";
import OverlayContainer from "./OverlayContainer";


const useStyles = makeStyles({
  map: {
    height: '100vh'
  }
});

function Map({ center, zoom, events }) {
  const ref = useRef(null);
  const [map, setMap] = useState(null);
  const classes = useStyles();

  useEffect(() => {
    if (ref.current) {
      let createdMap = new window.google.maps.Map(
        ref.current,
        {
          center,
          zoom,
          disableDefaultUI: true,
          clickableIcons: false
        }
      );
      setMap(createdMap);
    }
  }, [center, zoom]);

  return (
    <div ref={ref} id="map" className={classes.map}>
      {events.map((event) => (
        <OverlayContainer
          map={map}
          position={{
            lat: event.lat,
            lng: event.lng
          }}
          key={event.id}
        >
          <MapPoint
            event={event}
            index={event.id}
          />
        </OverlayContainer>
      ))}
    </div>
  );
}

export default Map;
